module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"en":{"fakeOrderText":"Draft Sample Order"},"de":{"fakeOrderText":"Entwurf Musterauftrag"}}')
  delete Component.options._Ctor
}
